import React from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

const MemberItem = ({ t, contact, dark }) => {
    const className = dark ? 'dark' : ''

    return (
        <div className={`contact-card contact-card--${className}`}>
            <div
                style={{ backgroundImage: `url("${contact.contactImage}")` }}
                className="contact-card__avatar"
            />
            <div className="contact-card__content">
                <ul>
                    <li className="contact-card__content__full-name">{`${contact.name} ${
                        contact.surname
                    }`}</li>
                    <li className="contact-card__content__position">{contact.position}</li>
                    {contact.company && (
                        <li className="contact-card__content__company">{contact.company.name}</li>
                    )}
                </ul>
                {contact.phoneNumbers.length > 0 && (
                    <ul>
                        <li className="contact-card__content__info">
                            <h6 className="contact-card__content__info__category">
                                {t('contacts.tel')}
                            </h6>
                            <div className="contact-card__content__info__content">
                                {contact.phoneNumbers.map((tel, i) => (
                                    <div key={i}>{tel}</div>
                                ))}
                            </div>
                        </li>
                        {/*
                <li id="fax" className="contact-card__content__info">
                    <h6 className="contact-card__content__info__category">{t('contacts.fax')}</h6>
                    <div className="contact-card__content__info__content">
                        {contact.faxNumbers.map((fax, i) => (
                            <div key={i}>{fax}</div>
                        ))}
                    </div>
                </li>
             */}
                    </ul>
                )}
                {contact.emails.length > 0 && (
                    <ul>
                        <li className="contact-card__content__info">
                            <h6 className="contact-card__content__info__category">E-mail</h6>
                            <div className="contact-card__content__info__content contact-card__content__info__email">
                                {contact.emails.map((email, i) => (
                                    <a href={`mailto:${email}`} key={i}>
                                        {email}
                                    </a>
                                ))}
                            </div>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    )
}
MemberItem.propTypes = {
    t: PropTypes.func,
    dark: PropTypes.bool
}

export { MemberItem }
export default withTranslation()(MemberItem)
